/**
 * Adds back a ')' to the end of the tag string in case its missing
 *
 * @param {string} tagString - The string of the Tag in question
 */
export const fixTagString = (tagString) => {
    const tagWords = tagString.split(' ');
    const lastWord = tagWords[tagWords.length - 1];
    if (lastWord.startsWith('(')) tagString += ')';
    return tagString;
};